/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2023-04-05 20:09:14
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2025-05-19 13:48:12
 * FilePath     :\AV-COM-user-backend\src\utils\util.js
 * RevisionHistory:
 */
// vxe-table滚动条是否触底
export function iScrollBottom(e) {
    const scrollEle = e.$event.srcElement
        ? e.$event.srcElement
        : e.$event.target;
    const isTobotomm =
        Math.ceil(scrollEle.scrollTop) + scrollEle.offsetHeight >=
        scrollEle.scrollHeight;
    console.log("[ isTobotomm ] >", isTobotomm);
    return isTobotomm;
}

// 一般防抖 无论触发几次，只算最后一次
export function debounce(fn, delay) {
    // 维护一个 timer
    let timer = null;

    return function () {
        // 通过 ‘this’ 和 ‘arguments’ 获取函数的作用域和变量
        const context = this;
        const args = arguments;

        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
        console.log("Debounced function called");
    };
}

function theParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
}
// 获取当前语言
export function currentLang() {
    const supportedLanguages = [
        "de",
        "fr",
        "es",
        "en",
        "it",
        "jp",
        "tw",
        "cn",
        "pt",
        "zh-CN",
    ];
    const segments = theParam("lang");
    let lang = segments;
    if (window.location.host === "www.anyviewer.cn") {
        lang = "cn";
    }
    return supportedLanguages.includes(lang) ? lang : "en";
}

// 用于传递参数的语言 海外版本：en zh-CN de fr jp it pt es， 国内 cn
export function apiLang() {
    let lang = currentLang();
    if (process.env.NODE_ENV == "development") {
        lang = lang;
    } else {
        if (window.location.host === "www.anyviewer.cn") {
            lang = "cn";
        } else {
            lang = lang === "cn" || lang === "zh-CN" ? "zh-CN" : lang;
        }
    }

    // alert(lang)
    return lang;
}

export const productID =
    apiLang() === "cn"
        ? "22d77b5b-94e1-31b0-ba32-3a89fcfddf6a"
        : "9a3de8f-daf4-37a3-b80e-8c1ac1abcbab";

// 重定向地址
export function redirectURL() {
    let redirect = "";
    switch (apiLang()) {
        // case "en":
        //     redirect = "www.anyviewer.com";
        //     break;
        case "cn":
            redirect = "www.anyviewer.cn";
            break;
        default:
            redirect = "www.anyviewer.com";
            break;
    }
    return redirect;
}

// base64解码
export function decodeBase64(base64String) {
    // const decodedURIComponent = decodeURIComponent(base64String); // 先 URL 解码
    const binaryString = atob(base64String);
    return new TextDecoder().decode(
        Uint8Array.from(binaryString, (c) => c.charCodeAt(0))
    );
}

// export const version = window.location.hostname === "www.anyviewer.cn" ? "GN" : "GW"; // 国内|国外
export const version = (function ver() {
    // 国内|国外
    if (process.env.NODE_ENV == "development") {
        return theParam("lang") === "cn" ? "GN" : "GW";
    } else {
        return window.location.hostname === "www.anyviewer.cn" ? "GN" : "GW";
    }
    // return window.location.hostname === "www.anyviewer.cn" ? "GN" : "GW";
    // return theParam("lang") === "cn" ? "GN" : "GW";
})();
export const thirdAuthURL = function (type) {
    let success = "";
    let auth = "";
    let callback = "";
    if (process.env.NODE_ENV == "development") {
        success = "http://192.168.0.27:8080";
        callback = "https://usertest.anyviewer.com/rest";
        // callback = "https://user.anyviewer.com/rest";
        // success = version === "GN" ? "https://www.anyviewer.cn/user" : "https://www.anyviewer.com/user";
        // callback = "https://user.anyviewer.com/rest";
    } else {
        success =
            version === "GN"
                ? "https://www.anyviewer.cn/user"
                : "https://www.anyviewer.com/user";
        callback = "https://user.anyviewer.com/rest";
    }

    auth =
        version === "GN" && type === "wechat"
            ? "https://auth.anyviewer.cn/oauth"
            : "https://auth.anyviewer.com/oauth";
    return {
        auth,
        callback,
        success,
    };
};
